/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Chairs/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CoreEmbeddableSection from 'DesignSystem/CoreEmbeddableSection/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Chairs({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Chairs"
  
}) {
let globalCurrentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location._id',
})
let tabCoreParamsValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'coreParams',
})
let globalRefreshEmbeddedSectionValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'refresh_embedded_section',
})
let globalSessionExpiredRefreshEmbeddedSectionValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'session_expired_refresh_embedded_section',
})
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<CoreEmbeddableSection
  viewPath={`${viewPath}/CoreEmbeddableSection`}
 section_type="chairs"
 data="global.current_location._id"
 location_id={globalCurrentLocationIdValueData}
 data="tab.coreParams"
 params={tabCoreParamsValueData}
 data="global.refresh_embedded_section"
 refresh={globalRefreshEmbeddedSectionValueData}
 data="global.session_expired_refresh_embedded_section"
 session_expired_refresh={globalSessionExpiredRefreshEmbeddedSectionValueData}
/>
{children}
</React.Fragment>)
}